import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { doJoinGame, fetchCountry } from '../../apiservices/axiosservice/gameservice';
import { saveGameDetails } from '../../apiservices/LocalStorageService';
import { sseManager } from '../../sse';
import './PlayerFlow.css';

const avatars = ['😎', '🦊', '🐋', '🚀', '🌿', '🦁', '🎩', '🌸', '🐱', '🎮'];

const PlayerLogin: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const gameIdFromState = queryParams.get('gameId') || location.state?.gameId || '';
  const [displayName, setDisplayName] = useState('');
  const [email, setEmail] = useState('');
  const [gameCode, setGameCode] = useState(gameIdFromState);
  const [avatar, setAvatar] = useState('😎');
  const [showAvatars, setShowAvatars] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [country, setCountry] = useState('');


  useEffect(() => {
    fetchCountry().then(setCountry).catch(() => {});
  }, []);

  const handleJoin = async () => {
    if (!displayName.trim()) { setError('Please enter a display name'); return; }
    if (!gameCode.trim()) { setError('Please enter a game code'); return; }
    setLoading(true);
    setError('');
    try {
      const res = await doJoinGame({ gameId: gameCode, playerName: displayName, countryName: country, email, playerIcon: avatar });
      const data = res?.data ?? res;
      if (data) {
        saveGameDetails(data);
        sseManager.connect(data.gameId || gameCode);
        navigate('/welcome');
      }
    } catch (err: any) {
      setError(err.message || 'Failed to join game');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pf-login">
      <div className="pf-login__left">
        <img src="/logo.png" alt="FunHives" className="pf-login__logo" onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }} />
        <h2 className="pf-login__brand">Fun<span>Hives</span>.com</h2>
        <p className="pf-login__tagline">PLAY · KNOW · CREATE</p>
        <p className="pf-login__desc">Join your friends in exciting quizzes, geo guess challenges, and creative games!</p>
      </div>
      <div className="pf-login__right">
        <div className="pf-login__card">
          <h1 className="pf-login__title">Join Game</h1>

          <div className="pf-login__avatar-wrap" onClick={() => setShowAvatars(!showAvatars)}>
            <span className="pf-login__avatar">{avatar}</span>
            <p className="pf-login__avatar-hint">Tap to choose your avatar</p>
          </div>
          {showAvatars && (
            <div className="pf-login__avatar-grid">
              {avatars.map((a) => (
                <span key={a} className={`pf-login__avatar-opt ${avatar === a ? 'pf-login__avatar-opt--active' : ''}`} onClick={() => { setAvatar(a); setShowAvatars(false); }}>{a}</span>
              ))}
            </div>
          )}

          {error && <p className="pf-login__error">{error}</p>}

          <label className="pf-login__label">Display Name</label>
          <input className="pf-login__input" value={displayName} onChange={(e) => setDisplayName(e.target.value)} placeholder="Enter your name" />

          <label className="pf-login__label">Email</label>
          <input className="pf-login__input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Optional" />

          <label className="pf-login__label">Game Code</label>
          <input className="pf-login__input pf-login__input--code" value={gameCode} onChange={(e) => setGameCode(e.target.value.toUpperCase())} placeholder="QV8K3M" maxLength={10} />

          <button className="pf-login__btn" onClick={handleJoin} disabled={loading}>
            {loading ? 'Joining...' : 'Join Game'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlayerLogin;
